import {alias, createModelSchema} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {Schema} from "@/common/Schema";
// import {Metadata} from "@/common/Metadata";

export class FolderModel extends BaseObject {

    constructor(name) {
        super();

        this._name = name;
        // this._order = order;

        // this._group = group;
        // this._tag = null;
        // this._meta = null;
        // this._deployed = false;
        // this._info = ""
        // this._historyId = null;
        // this._mapId = mapId;

        // this._marker = null;
        // this._mapId = this._mapId || 0;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }
    //
    // get group() {
    //     return this._group;
    // }
    //
    // set group(value) {
    //     this._group = value;
    // }
    //
    // get info() {
    //     return this._info;
    // }
    //
    // set info(value) {
    //     this._info = value;
    // }
    //
    // get tag() {
    //     return this._tag;
    // }
    //
    // set tag(value) {
    //     this._tag = value;
    // }
    //
    // get meta() {
    //     return this._meta;
    // }
    //
    // set meta(value) {
    //     this._meta = value;
    // }
    //
    // get deployed() {
    //     return this._deployed;
    // }
    //
    // set deployed(value) {
    //     this._deployed = value;
    // }
    //
    // get mapId() {
    //     return this._mapId;
    // }
    //
    // set mapId(value) {
    //     this._mapId = value;
    // }
    //
    // get marker() {
    //     return this._marker;
    // }
    //
    // set marker(value) {
    //     this._marker = value;
    // }


    copy() {
        return super.copy();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new FolderModel());
        } else if (target instanceof FolderModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(FolderModel, {
    _uid: alias("uid", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    // _tag: alias("tag", Schema.primitive()),
    // _meta: alias("meta", Metadata.schema()),
    // _deployed: alias("deployed", Schema.primitive()),
    // _info: alias("info", Schema.primitive()),
    // _historyId: alias("historyId", Schema.primitive()),
    // _mapId: alias("mapId", Schema.primitive()),
    // _marker: alias("marker", Schema.primitive()),
});